@if (dataIsLoaded) {
  <div [class.new-home-page]="isNewHomePageMarket$ | async">
    @for (item of data; track item; let i = $index) {
      @if (hasInnerText(item.name)) {
        <span class="menu-item">
          <a
            uDcSRemoveUsanaPhSubdomainShop
            [attr.href]="item.url"
            (click)="handleLink($event, item.url, item.target)"
            attr.data-automation="{{ urlPathId(item.url) }}"
            target="{{ item.target }}"
            [ngClass]="{ 'active-link': isActiveLink(item) }"
            id="dropdownMenu{{ i }}"
            class="navLink"
            [innerHTML]="item.name | uppercase"
          ></a>
        </span>
      }
    }
  </div>
}
